import React from 'react';
import { connect } from 'react-redux';
import { Row, Col, Button, notification, Checkbox } from 'antd';
import { get, patch } from '../../../utils'; 

import startedPatternOne from '../../../resource/screen-mobile/started-pattern/started-pattern-two.png'
import startedPatternTwo from '../../../resource/screen-mobile/started-pattern/started-pattern-three.png'


const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description,
    });
};

class StartedPatternScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            settingScreenMobileId: null,
            startedPattern: 1,
            startedPatternList: [
                { value: 1, name: 'Home Swipe One', image: startedPatternOne },
                { value: 2, name: 'Home Swipe Two', image: startedPatternTwo },
            ],
        }
    }

    getSettingScreenMobile() {
        let url = '/api/crm/administrator/setting/screen/mobile';
        get(url)
            .then(response => {
                this.setState({
                    settingScreenMobileId: response.id,
                    startedPattern: response.started_pattern
                })
            })
            .catch(err => {
                console.log(err.message)
            })
    }

    componentDidMount() {
        this.getSettingScreenMobile()
    }


    updateSettingScreenMobile() {
        const { settingScreenMobileId, startedPattern } = this.state
        let url = '/api/crm/administrator/setting/screen/mobile/' + settingScreenMobileId + '/started/pattern';
        let data = { started_pattern: startedPattern }
        patch(url, data)
            .then(response => {
                openNotificationWithIcon('success', 'System notification', 'Save setting screen mobile started pattern success.')
            })
            .catch(err => {
                console.log(err.message)
            })
    }

    onClickOk() {
        this.updateSettingScreenMobile()
    }
    onClickCancel() {
        this.getSettingScreenMobile()
    }


    updateHomeSwiper(value) {
        this.setState({ startedPattern: value })
    }

    getRoleEnabled() {
        const { roleDetail } = this.props
        if (roleDetail) {
            let index = roleDetail.findIndex(item => item.key === 'mobile')
            if (index != -1) {
                return roleDetail[index].edit
            }
            return false
        }
        return false
    }

    render() {
        const { startedPatternList } = this.state
        return (
            <div >
                <Row >
                    <Col span={12} style={{ textAlign: 'left' }}>
                    </Col>
                    <Col span={12} style={{ textAlign: 'right' }}>
                        <Button
                            style={{
                                marginLeft: 2, marginRight: 2,
                                backgroundColor: this.getRoleEnabled() ? '#ffffff' : '#BFBFBF',
                                color: this.getRoleEnabled() ? 'rgb(72, 197, 235)' : '#ffffff',
                                border: this.getRoleEnabled() ? '1px solid rgb(72, 197, 235)' : '#ffffff',
                            }}
                            disabled={!this.getRoleEnabled()}
                            onClick={() => this.onClickCancel()}
                        >
                            {'Cancel'}
                        </Button>
                        <Button
                            style={{
                                marginLeft: 2, marginRight: 2,
                                backgroundColor: this.getRoleEnabled() ? 'rgb(72, 197, 235)' : '#BFBFBF',
                                color: this.getRoleEnabled() ? '#ffffff' : '#ffffff',
                                border: this.getRoleEnabled() ? '1px solid rgb(72, 197, 235)' : '#ffffff',
                            }}
                            disabled={!this.getRoleEnabled()}
                            onClick={() => this.onClickOk()}
                        >
                            {'Save'}
                        </Button>
                    </Col>
                </Row>
                <div className="mobile-screen-content-wrapper">
                    {startedPatternList.map(item => {
                        return (
                            <div className="item-mobile-screen-wrapper">
                                <Checkbox
                                    className='item-mobile-screen-checkbox-wrapper'
                                    checked={item.value == this.state.startedPattern}
                                    onChange={() => this.updateHomeSwiper(item.value)}
                                />
                                <div
                                    className='item-mobile-screen-image-wrapper'
                                    onClick={() => this.updateHomeSwiper(item.value)}
                                >
                                    <img
                                        src={item.image}
                                        className='item-mobile-screen-image'
                                        style={{ border: item.value == this.state.startedPattern ? '4px solid #48c5eb' : 'none' }}
                                    />
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => ({
    roleDetail: state.role.roleDetail,
})

export default connect(mapStateToProps, null)(StartedPatternScreen);
